module.exports = __webpack_public_path__ + "static/media/ThankYouMobile.ae702a37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/campaign/ThankYouMobile.jpg
// module id = 1553
// module chunks = 0